import React from 'react';
import Dots from './dots';
import Items from './items';
import { Product } from '../../types';

type OwnProps = {
  clientWidth: number;
  dotWidthVal?: number;
  products: Product[];
  scrollPosition: number;
  totalVisibleItems?: number;
  totalVisibleDots?: number;
};

const CompareCarousel = ({
  clientWidth,
  dotWidthVal = 15,
  products,
  scrollPosition,
  totalVisibleItems = 2,
  totalVisibleDots = 5,
}: OwnProps) => {
  const columnWidth = clientWidth / totalVisibleItems;
  const cardIndex = Math.round(scrollPosition / columnWidth);
  const activeIndexes = [...Array(totalVisibleItems)].map(
    (val, index) => cardIndex + index
  );

  return (
    <>
      <Items
        columnWidth={columnWidth}
        positionIndexes={activeIndexes}
        products={products}
        totalVisibleItems={totalVisibleItems}
      />
      {products.length > 2 && (
        <Dots
          dotWidthVal={dotWidthVal}
          products={products}
          positionIndexes={activeIndexes}
          totalActiveDots={totalVisibleItems}
          totalVisibleDots={totalVisibleDots}
        />
      )}
    </>
  );
};

export default CompareCarousel;
